import React from 'react';

/* Natpis „TMS" u retro temi — u maniru filmskog plakata iz osamdesetih.
 *
 * Zašto SVG, a ne CSS: pokušaj sa `text-shadow` i `background-clip: text` ne
 * može da da tri stvari koje taj izgled NOSE —
 *   1. perspektivu: svako slovo mora biti svoje mere i na svojoj visini, a
 *      `text-shadow` se primenjuje na ceo natpis odjednom;
 *   2. crnu konturu OKO preliva: `background-clip: text` i `-webkit-text-stroke`
 *      se tuku, a kontura od senki prekrije preliv (senka se crta iznad
 *      pozadine isečene na tekst);
 *   3. telo kao pun blok: niz senki po dijagonali daje crtice, ne telo.
 * U SVG-u je sve troje obično: `transform` po slovu, `paint-order: stroke` i
 * gomila kopija jedna ispod druge.
 *
 * Pismo je `Arial Black` — na Windowsu je uvek tu, a od sistemskih je jedino
 * dovoljno široko i teško da liči na slova sa plakata. `Impact` je bio prvi
 * izbor i promašaj: on je UZAK, a plakat je širok.
 */

/* Perspektiva beži ULEVO→UDESNO: prvo slovo je najbliže oku (najveće, najniže),
   svako sledeće je manje i više — kao da natpis odlazi u daljinu nadesno.
   Nedogled je zato DESNO od natpisa.
   Vrhovi slova ostaju u istoj liniji, a dno se penje; to je ono što oko čita
   kao dubinu, a ne sam nagib slova. */
const SLOVA = [
    { znak: 'T', x: 2,   y: 70, mera: 1.34 },
    { znak: 'M', x: 46,  y: 63, mera: 1.16 },
    { znak: 'S', x: 100, y: 57, mera: 1.00 },
];

/* Koliko kopija gradi telo i koliko se svaka pomeri. Sitan korak (ispod 1px po
   kopiji) je ono što telo čini punim umesto prugastim. */
const DUBINA = 16;
const KORAK_X = 0.5;
const KORAK_Y = 0.9;

const PISMO = '"Arial Black", "Arial Bold", Gadget, sans-serif';
const VELICINA = 56;
const NAGIB = -9;

/* Bok slova je srebro, kao na plakatu: skoro beo tik uz lice, pa brzo u sredrnju
   sivu, pa u tamnu. Pad NIJE ravnomeran — metal se tako i ponaša: odsjaj uz
   ivicu je uzak, a telo odmah ispod njega je mnogo tamnije. Ravnomeran pad
   izgleda kao siva plastika, ne kao metal. */
const SREBRO = [
    { na: 0.00, boja: [238, 245, 249] },
    { na: 0.18, boja: [199, 211, 219] },
    { na: 0.45, boja: [138, 150, 159] },
    { na: 0.75, boja: [84, 94, 102] },
    { na: 1.00, boja: [46, 54, 60] },
];

const bojaTela = (i) => {
    const t = i / DUBINA;                       /* 0 = uz lice, 1 = najdublje */
    let a = SREBRO[0];
    let b = SREBRO[SREBRO.length - 1];
    for (let k = 0; k < SREBRO.length - 1; k += 1) {
        if (t >= SREBRO[k].na && t <= SREBRO[k + 1].na) {
            a = SREBRO[k];
            b = SREBRO[k + 1];
            break;
        }
    }
    const raspon = b.na - a.na || 1;
    const d = (t - a.na) / raspon;
    const c = a.boja.map((v, k) => Math.round(v + (b.boja[k] - v) * d));
    return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
};

const Slova = ({ ispuna, ivica, debljina }) => (
    <>
        {SLOVA.map(s => (
            <text
                key={s.znak}
                x="0"
                y="0"
                transform={`translate(${s.x} ${s.y}) scale(${s.mera}) skewX(${NAGIB})`}
                fontFamily={PISMO}
                fontSize={VELICINA}
                fontWeight="900"
                fill={ispuna}
                stroke={ivica}
                strokeWidth={debljina}
                strokeLinejoin="round"
                paintOrder="stroke"
            >
                {s.znak}
            </text>
        ))}
    </>
);

const LogoRetro = ({ naziv = 'TMS' }) => (
    <svg
        className="tms-retro-logo"
        viewBox="0 0 158 92"
        role="img"
        aria-label={naziv}
        focusable="false"
    >
        <defs>
            {/* Preliv je slikan aerografom: pojasevi su jasni, pa su i prelazi
                kratki. Razvučen preliv izgleda kao providna plastika. */}
            <linearGradient id="tmsLice" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#fff7cf" />
                <stop offset="24%" stopColor="#ffdf5a" />
                <stop offset="44%" stopColor="#ffb21d" />
                <stop offset="60%" stopColor="#f87a18" />
                <stop offset="72%" stopColor="#ee3d12" />
                <stop offset="88%" stopColor="#cf1a0b" />
                <stop offset="100%" stopColor="#9c1107" />
            </linearGradient>
        </defs>

        {/* Telo, od najdublje kopije ka licu. Najdublja nosi crnu konturu i time
            uokviruje ceo blok; one iznad nje su bez konture, inače bi se kroz
            telo videle linije svake pojedine kopije. */}
        {Array.from({ length: DUBINA }, (_, k) => DUBINA - k).map(i => (
            <g key={i} transform={`translate(${i * KORAK_X} ${i * KORAK_Y})`}>
                <Slova
                    ispuna={bojaTela(i)}
                    ivica={i === DUBINA ? '#160300' : 'none'}
                    debljina={i === DUBINA ? 5 : 0}
                />
            </g>
        ))}

        {/* Lice: preliv, pa crna kontura ispod njega (`paint-order: stroke`),
            pa tanka žuta linija kao poslednji sloj — ona je ono što natpisu daje
            „sjaj" i odvaja ga od tela. */}
        <Slova ispuna="url(#tmsLice)" ivica="#160300" debljina={5} />
        <Slova ispuna="url(#tmsLice)" ivica="#ffd84d" debljina={1.6} />
    </svg>
);

export default LogoRetro;
